module.exports = __webpack_public_path__ + "static/FlowVectors-94a0d46d3a59b5db1c4928098b1cc33e.png";